import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import WarningIcon from '../../../src/components/LoaderImg/Avatar.svg';
import { useSelector } from 'react-redux';

type Props = {
  close: any;
  handleDelete: any;
};

const ConfirmDeleteModal = (props: Props) => {
  const { close, handleDelete } = props;
  const removePtoReducer = useSelector((state: any) => state.removePtoRequestReducer);
  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box p={1}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  marginRight: '12px',
                }}
              >
                <img
                  alt=""
                  src={WarningIcon}
                />
              </div>
            </Box>
            <Box>
              <Typography variant="h5">Delete PTO Request</Typography>
              <Typography
                sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                variant="body2"
                mt={0.2}
              >
                Are you sure you want to delete this request? Deleted requests will not be visible
                to DOR.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            sx={{ color: '#111927' }}
            onClick={close}
          >
            close
          </Button>
          <Button
            autoFocus
            variant="contained"
            sx={{
              background: '#F04438',
              color: '#fff',
              '&:hover': {
                background: '#F04438',
              },
            }}
            onClick={handleDelete}
            disabled={removePtoReducer.loader}
          >
            Delete
          </Button>
        </DialogActions>
      </>
    </Box>
  );
};

export default ConfirmDeleteModal;
